import {
  GET_SCHEDULE_DATE_DETAIL,
  GET_SCHEDULE_DATE_DETAIL_SUCCESS,
  GET_SCHEDULE_DATE_DETAIL_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getScheduleDateDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCHEDULE_DATE_DETAIL:
      return { ...state, loading: true };
    case GET_SCHEDULE_DATE_DETAIL_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_SCHEDULE_DATE_DETAIL_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getScheduleDateDetailReducer;
